import { render, staticRenderFns } from "./ParentInformation.vue?vue&type=template&id=36e73c96&scoped=true"
import script from "./ParentInformation.vue?vue&type=script&lang=js"
export * from "./ParentInformation.vue?vue&type=script&lang=js"
import style0 from "./ParentInformation.vue?vue&type=style&index=0&id=36e73c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e73c96",
  null
  
)

export default component.exports